import moment from 'moment';

export class EventDateModel {
  private _start: Date;
  private _end?: Date;
  private _note: string;
  private _realEnd?: Date;
  constructor(start: Date, end?: Date, note?: string) {
    this._realEnd = end;
    if (!end || end < start) {
      //console.error('End date is before start date');
      end = moment(start).add(2, 'hour').toDate();
    }
    this._start = start;
    this._end = end;
    this._note = note || '';
  }

  public static from(data: EventDateModel) {
    return new EventDateModel(
      new Date(data._start),
      data._end ? new Date(data._end) : undefined,
      data._note
    );
  }

  public get note() {
    return this._note;
  }

  get start() {
    return this._start;
  }

  get end() {
    return this._end;
  }

  get realEnd() {
    return this._realEnd;
  }

  get isFullDay() {
    const start = moment(this.start).utc();
    if (start.hour() !== 0 || start.minute() !== 0) return false;
    const end = moment(this.end).utc();
    const diff = start.diff(end, 'hours');
    const diffIndicatesFullDay = Math.abs(diff) >= 24 && Math.abs(diff) < 26;
    return (
      (start.hours() === 0 && start.minutes() === 0) || diffIndicatesFullDay // && this._realEnd == null
    );
  }

  get formattedBeginEnd() {
    const startTime = moment(this.start);

    const sameYear = startTime.year() === moment().year();

    const dateFormat = sameYear ? 'DD.MM.' : 'DD.MM.YYYY';
    const timeFormat = 'HH:mm';

    const dateOnlyFormat = dateFormat;
    const dateTimeFormat = `${dateFormat} ${timeFormat}`;

    const startTimeFormat = this.isFullDay ? dateOnlyFormat : dateTimeFormat;

    if (!this._realEnd) return startTime.format(startTimeFormat);

    const endTime = moment(this._realEnd);

    if (endTime.isValid() === false) return startTime.format(startTimeFormat);

    const spansMultipleDays = startTime.date() !== endTime.date();

    let formattedString;
    if (spansMultipleDays) {
      formattedString = `${startTime.format(
        startTimeFormat
      )} - ${endTime.format(startTimeFormat)}`;
    } else {
      if (this.isFullDay) return startTime.format(dateOnlyFormat);

      formattedString = `${startTime.format(startTimeFormat)}-${endTime.format(
        timeFormat
      )}`;
    }

    return formattedString;
  }
}
